export interface TimeZone {
  id: string;
  timeZoneStandardName: string;
  abbreviation: string;
  displayName: string;
  highlighted: boolean;
  gmtDescription: string;
  offset: string;
}
export interface VirtualBookingAdditionalDetail {
  category:Item;
  virtualBookingAdditionalDetails: VirtualOption[]
 }
export interface VirtualOption extends ItemWithDescription{
  technologies: string[];
}
export interface Item {
  id: number;
  name: string;
}
export enum AdditionalDetailscategory {
  SetUpRequirements = 1,
  collaborativeFeatures = 2,
  dayOfSupport = 3,
  breakoutRooms = 4
}
export interface TaskType extends ItemWithDescription {
  shortDescription: string;
}
export interface ItemWithDescription {
  id: number;
  description: string;
}
export interface ServiceOrderType extends ItemWithDescription {
  shortDescription: string;
  serviceOrderTypeId: number;
  serviceOrderCategory: string;
}

export enum ServiceOrderCategories {
  catering = 'catering',
  task = 'TaskType',
}

export interface Neighborhood extends Item {
  buildingIds: number[];
}
export interface Status extends ItemWithDisplayName{
  isActiveStatus: boolean;
}
export interface SpaceType extends Item{
  type: string;
}
export interface SpaceFeature extends Item {
  iconKey?: string;
  isHighlighted?: boolean;
  iconClass: string;
  selected?: boolean;
  width?: number;
  amount?: number
}
export interface EventType extends ItemWithDescription {
  readonly: boolean;
  displayOrder: number;
}
export interface SpaceSetupType extends ItemWithDescription {
  displayOrder: number;
  iconClass?: string;
}
export interface Configuration {
  name: string;
  value: string;
}
export interface ViewTab extends Item{
  tabFields: Item[];
  subTabs: SubTab[];
}
export interface SubTab {
  name: string;
  tabFields: Array<Item>;
  includeDelete: boolean;
}
export interface ItemWithDisplayName extends Item{
  displayName: string;
}
export interface AttachmentFileExtension extends ItemWithDescription {
  fileType: string;
  extension: string;
  isDeleted: boolean;
}
export interface AttachmentFileType {
  attachmentTypeId: number;
  attachmentType: string;
  lastChangeUtc: string;
}
export interface StatusReasons extends Reason {
  statusReasons: Reason[];
}
export interface Reason {
  id: number;
  name: string;
  isActive: boolean;
  lastChangeUtc: string;
  description: string;
}
export interface Amenity extends Item{
  iconLinks: IconLinks;
}
export interface IconLinks {
  bigFilled: string;
  bigLine: string;
  smallLine: string;
}
export interface JobTitle extends Item{
  isActive: boolean;
  sortOrder: number;
  isDefault: boolean;
}
export interface Building extends Item{
  displayName: string;
  addressShort: string;
  city: string;
  stateShort: string;
  country: string;
  zip: string;
  region: string;
  contactEmail: string;
  contactPhone: string;
  contactName: string;
  managementPhone: string;
  securityPhone: string;
  latitude: number;
  longitude: number;
  walkUpItems: {
    additionalProp1: AdditionalProp;
    additionalProp2: AdditionalProp;
    additionalProp3: AdditionalProp;
  };
  evacuationAssemblyPoint: string[];
  parkingInfo: string[];
  floors: Floor[];
  workingDates: [{date: string; isWorking: boolean;}];
  buildingAccess: string[];
  timeZoneOffSet: number;
  timeZoneShortName: string;
  timeZoneStandardName: string;
  timeZoneIanaName: string;
  cateringRequestAvailable: boolean;
  wayfindingAvailable: boolean;
  parkingAvailable: boolean;
  waitListRequestAvailable: boolean;
  meetingWaitListRequestAvailable: boolean;
  cafeteriaAvailable: boolean;
  foodOptions: string[];
  transitInfo: string[];
  specialAnnouncements: string[];
  visitorSpecialAnnouncements: string[];
  visitorParkingInfo: string[];
  visitorBuildingAccess: string[];
  enabledInDGuest: boolean;
  memberFirm: MemberFirm;
}
export interface AdditionalProp {
  title: string;
  hours: string;
  email: string;
  phoneNumber: string;
  services: string[];
}
export interface Floor {
  uniqueKey: number;
  name: string;
  mapUrl: string;
  description: string;
  favorite?: boolean;
  amenities: FloorAmenity[];
}
export interface FloorAmenity {
  id: number;
  name: string;
  description: string;
  iconSize: number;
  center: {
    x: number;
    y: number;
  };
  iconLinks?: IconLinks;
}
export interface MemberFirm {
  id: number;
  name: string;
  code: string
}

export interface Space {
  id: number,
  name: string,
  buildingId:	number,
  buildingDisplayName: string,
  floorUniqueKey:	number,
  floorName: string,
  spaceType: SpaceType,
  centerCoordinates: {
    x: number,
    y: number,
    pointSize: number
  },
  sizeCoordinates: {
    top: number,
    left: number,
    width: number,
    height: number
  },
  capacity:	number,
}

export interface TechnologyType {
  DisplayName: string,
  ActualName: string,
}

export interface IdWithRevision {
  id: number;
  revision: number;
}
export interface StatusReason extends Item{
  comment: string;
}
export interface ItemForSubType {
  Id: number;
  Name: string;
}

export interface ItemWithDisplayNameForSubType extends ItemForSubType {
  DisplayName: string;
}
export interface Technology {
  DisplayName: string;
  ActualName: string;
}
export interface CateringOrder{
  Id: number;
  Name: string;
  DisplayName: string;
}



//Enums
export enum BuildingFeatureFlagsEnum {
  Undefined,
  IncludeFloorAmenities,
  IncludeFloorInformation,
  IncludeWorkingDates,
}
export enum SpaceTypeCategory {
  Individual = 0,
  Meeting = 1
}

export enum SpaceCategory {
  Individual = 'Individual',
  Meeting = 'Meeting'
}
 
export const SPACE_CATEGORY_BY_TYPE = {
  MeetingRoom: SpaceTypeCategory.Meeting,
  Workstation: SpaceTypeCategory.Individual,
  PrivateSpace: SpaceTypeCategory.Individual,
  OpenSeating: SpaceTypeCategory.Meeting
};

export const SPACE_CATEGORY_BY_NAME = {
  'Meeting Room': SpaceTypeCategory.Meeting,
  Workstation: SpaceTypeCategory.Individual,
  'Private Space': SpaceTypeCategory.Individual,
  'Open Seating': SpaceTypeCategory.Meeting
};
export class Facility {
  Facilityid: number;
  OfficeName: string;
  TZOffSet: number;
  TZIanaName: string;
  TZStandardName: string;
  TZShortName: string;
  EnableWaitListRequest: boolean;
  EnableCateringRequest: boolean;
  EnableDGuest: boolean;
  ContactEmail: string;
  Floors: Array<Floor>;
  EnableMeetingRequest: boolean;
  Country: string;
  MemberFirm: MemberFirm;
};
export interface Country {
  id: number;
  name: string;
  code: number;
}
export enum CountryName {
  US = 'United States',
  India = 'India',
  Mexico = 'Mexico',
  Chile = 'Chile',
  Canada='Canada'  
}
